import { Box, Stack, ThemeProvider } from '@mui/material';
import React from 'react';
import { Provider } from 'react-redux';
import { store } from '../store/store';
import StreamChat from './components/aiChat/StreamChat';
import CompanyData from './components/CompanyData';
import Header from './components/Header';
import TokenValidator from './components/TokenValidator';
import { theme } from './theme';
import { IntlProvider } from 'react-intl';
import { LanguageProvider, useLanguage } from './context/LanguageContext';

const AppContent = () => {
	const { messages } = useLanguage();

	return (
		<IntlProvider messages={messages} locale='en' defaultLocale='en'>
			<TokenValidator>
				<Box sx={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 33px)' }}>
					<Header />
					<Stack
						flexDirection='column'
						justifyContent='space-between'
						sx={{ flex: 1, minHeight: 0, overflow: 'hidden', flexGrow: 1, backgroundColor: '#fff' }}
					>
						<CompanyData />
						<StreamChat />
					</Stack>
				</Box>
			</TokenValidator>
		</IntlProvider>
	);
};

export default function App() {
	return (
		<Provider store={store}>
			<ThemeProvider theme={theme}>
				<LanguageProvider>
					<AppContent />
				</LanguageProvider>
			</ThemeProvider>
		</Provider>
	);
}
